export const getUserSession = async () => {
  const backendURI = process.env.REACT_APP_STRIPPED_BACKEND_URI;
  const requestURL = "/API/auth/session";

  const response = await fetch(requestURL, {
    mode: "cors", // This is needed to avoid CORS issues
    method: "GET",
    credentials: "include",
    redirect: "manual",
  });

  if (response.status === 403 || response.status === 401) {
    // Backend returned Forbidden/Unauthorized (SessionGuard), so we must log in.
    return {
      redirectUrl: "/API/auth/login",
    };
  }

  // console.log("Session API response.type : " + response.type);

  if (response.type === "opaqueredirect") {
    const redirectionPath: string = window.location.pathname + window.location.hash;

    // console.log("Session API opaqueredirect response.type ");

    const loginURL = "/API/auth/login";

    // console.log("Session API opaqueredirect loginURL " + loginURL);

    return {
      redirectUrl: loginURL,
    };
  }

  // Check if the response is actually JSON
  const contentType = response.headers.get("content-type");
  if (!contentType || !contentType.includes("application/json")) {
    // Did we get an error page (HTML)?
    const text = await response.text();
    let errorShort = text.slice(0, 100);
    // Clean up newlines for the short message
    errorShort = errorShort.replace(/\r?\n|\r/g, " ");

    throw new Error(
      `Backend response was not JSON (Status: ${response.status} ${response.statusText}). Content-Type: ${contentType}. Body preview: "${errorShort}..."`,
    );
  }

  let result = await response.json();

  // console.log("Session API response.result : " + JSON.stringify(result));

  return result;
};

export const getSessionOrNavigateToLogin = () => {
  return getUserSession().then((response) => {
    if (response.redirectUrl) {
      window.location.assign(response.redirectUrl);
      //throw new Error('Session is missing or expired. Redirecting to login...');
      return new Promise(() => {});
    }

    return response;
  });
};

export const getInitialProps = async () => {
  const fetchSessionPromise = getSessionOrNavigateToLogin();
  const [userInfo] = await Promise.all([fetchSessionPromise]);

  return {
    userInfo,
  };
};
